import React from 'react';
import { Link } from 'react-router-dom';
import { Lightning } from '@phosphor-icons/react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background text-foreground p-6">
      <div className="max-w-3xl mx-auto pt-12">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <Lightning size={22} weight="fill" className="text-foreground" />
          <span className="font-heading text-lg font-bold text-foreground">Mayr Lead Creator</span>
        </Link>
        <h1 className="font-heading text-3xl font-bold text-foreground mb-6">Privacy Policy</h1>
        <div className="prose prose-sm text-muted-foreground space-y-4">
          <p>Mayr-Technologies takes your privacy seriously. This policy describes how we collect, use, and protect your data when you use the Mayr Lead Creator platform.</p>
          <p>We collect account information (name, email, company) and usage data (discovery jobs, leads created). We do not sell your data to third parties.</p>
          <p>Lead data you discover and manage is scoped to your account and is not shared with other users or accounts.</p>
          <p className="text-xs text-muted-foreground mt-8">Last updated: April 2026. Full privacy policy will be published before general availability.</p>
        </div>
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground underline mt-8 block">Back to home</Link>
      </div>
    </div>
  );
}
